import React from "react";
import Marquee from "react-fast-marquee";
import { ShoppingBag, Snowflake } from "lucide-react";
import { useCart, useLang } from "../store";
import { useT } from "../i18n";

export default function Header() {
  const { lang, setLang } = useLang();
  const { cartCount, setCartOpen } = useCart();
  const t = useT(lang);

  return (
    <header className="sticky top-0 z-40">
      {/* Top marquee strip */}
      <div className="bg-[#0C0A09] text-[#9BE800] border-b-[3px] border-[#0C0A09]">
        <Marquee speed={50} gradient={false} className="py-2">
          <span className="font-display tracking-[0.15em] text-sm md:text-base px-8">
            {t.marquee} ✦ {t.marquee} ✦
          </span>
        </Marquee>
      </div>

      <div className="bg-[#FAF9F6] border-b-[3px] border-[#0C0A09]">
        <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
          <a href="#top" data-testid="logo-link" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-full bg-[#FF3D7F] border-[3px] border-[#0C0A09] flex items-center justify-center">
              <Snowflake size={18} strokeWidth={3} />
            </div>
            <span className="font-display text-3xl md:text-4xl tracking-tight">VELORA</span>
          </a>

          <nav className="hidden lg:flex items-center gap-8 text-sm font-bold uppercase tracking-widest">
            <a data-testid="nav-pets" href="#pets" className="hover:underline underline-offset-4 decoration-[3px]">{lang === "es" ? "🐾 Mascotas" : "🐾 Pets"}</a>
            <a data-testid="nav-shop" href="#shop" className="hover:underline underline-offset-4 decoration-[3px]">{t.nav.shop}</a>
            <a data-testid="nav-reviews" href="#reviews" className="hover:underline underline-offset-4 decoration-[3px]">{t.nav.reviews}</a>
            <a data-testid="nav-faq" href="#faq" className="hover:underline underline-offset-4 decoration-[3px]">{t.nav.faq}</a>
          </nav>

          <div className="flex items-center gap-3">
            <div className="flex items-center border-[2px] border-[#0C0A09] rounded-full overflow-hidden text-xs font-bold">
              <button
                data-testid="lang-es"
                onClick={() => setLang("es")}
                className={`px-3 py-1.5 ${lang === "es" ? "bg-[#0C0A09] text-white" : "bg-white"}`}
              >ES</button>
              <button
                data-testid="lang-en"
                onClick={() => setLang("en")}
                className={`px-3 py-1.5 ${lang === "en" ? "bg-[#0C0A09] text-white" : "bg-white"}`}
              >EN</button>
            </div>
            <button
              data-testid="open-cart-btn"
              onClick={() => setCartOpen(true)}
              className="relative w-11 h-11 rounded-full bg-[#9BE800] border-[3px] border-[#0C0A09] flex items-center justify-center shadow-[3px_3px_0_0_#0C0A09] hover:-translate-y-0.5 transition-transform"
            >
              <ShoppingBag size={18} strokeWidth={2.5} />
              {cartCount > 0 && (
                <span
                  data-testid="cart-count-badge"
                  className="absolute -top-2 -right-2 min-w-[22px] h-[22px] px-1 rounded-full bg-[#0C0A09] text-white text-xs font-bold flex items-center justify-center border-2 border-white"
                >{cartCount}</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
